import React, { useEffect, useState, useCallback } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import Logo from '../assets/logo/kalpana-logo.png';

// ── K10 Offer items — edit here to update your offers ──────────────
const OfferItems = () => (
  <>
    <div className="k10-item"><span className="k10-off">NEW</span>"The Aroma of Tradition in Every Pack"<span className="k10-sep">✦</span></div>
    <div className="k10-item"><span className="k10-off">FREE</span>"Delivery above ₹499"<span className="k10-sep">✦</span></div>
    <div className="k10-item"><span className="k10-off">NEW</span>"Products added every day"<span className="k10-sep">✦</span></div>
    <div className="k10-item"><span className="k10-off">SALE</span>"Weekend Mega Deals Live Now"<span className="k10-sep">✦</span></div>
    <div className="k10-item"><span className="k10-off">HOT</span>"Top Brands at Best Prices"<span className="k10-sep">✦</span></div>
    <div className="k10-item"><span className="k10-off">FAST</span>"Same Day Dispatch Available"<span className="k10-sep">✦</span></div>
  </>
);

const HeaderOne = () => {
  const [scroll, setScroll]               = useState(false);
  const [cartCount, setCartCount]         = useState(0);
  const [wishlistCount, setWishlistCount] = useState(0);
  const [categories, setCategories]       = useState([]);
  const [drawerOpen, setDrawerOpen]       = useState(false);
  const [catOpen, setCatOpen]             = useState(false);
  const [headerHidden, setHeaderHidden]   = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScroll(window.pageYOffset > 100);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const fetchCounts = useCallback(async () => {
    const customer   = JSON.parse(localStorage.getItem('customer'));
    const customerId = customer?.id;
    if (customerId) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/user/counts?customerId=${customerId}`
        );
        if (response.ok) {
          const data = await response.json();
          setCartCount(data.cartCount || 0);
          setWishlistCount(data.wishlistCount || 0);
        }
      } catch (error) {
        console.error("Error fetching counts:", error);
      }
    } else {
      setCartCount(0);
      setWishlistCount(0);
    }
  }, []);

  useEffect(() => {
    fetchCounts();
    window.addEventListener("storage", fetchCounts);
    window.addEventListener("cartUpdated", fetchCounts);
    return () => {
      window.removeEventListener("storage", fetchCounts);
      window.removeEventListener("cartUpdated", fetchCounts);
    };
  }, [fetchCounts]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/categories`)
      .then(r => r.json())
      .then(data => setCategories(data))
      .catch(err => console.log("Category fetch failed:", err));
  }, []);

  useEffect(() => {
    if (drawerOpen) {
      document.body.style.overflow    = 'hidden';
      document.body.style.touchAction = 'none';
    } else {
      document.body.style.overflow    = '';
      document.body.style.touchAction = '';
    }
    return () => {
      document.body.style.overflow    = '';
      document.body.style.touchAction = '';
    };
  }, [drawerOpen]);

  useEffect(() => {
    const onFilterDrawer = (e) => setHeaderHidden(e.detail.open);
    window.addEventListener('shopFilterDrawer', onFilterDrawer);
    return () => window.removeEventListener('shopFilterDrawer', onFilterDrawer);
  }, []);

  const handleCategoryClick = (cat) => {
    navigate(`/shop?category=${encodeURIComponent(cat.name)}`);
    setDrawerOpen(false);
  };

  const closeDrawer = () => setDrawerOpen(false);

  return (
    <>
      <style>{`

        /* ════════════════════════════════════════════════════════════
           K10 — Offer Ticker Marquee
        ════════════════════════════════════════════════════════════ */
        .k10-marquee-outer {
          background: #FFF8E1;
          border-top: 2px dashed #F15A22;
          border-bottom: 2px dashed #F15A22;
          padding: 9px 0;
          overflow: hidden;
          width: 100%;
        }
        .k10-marquee-outer:hover .k10-track {
          animation-play-state: paused;
        }
        .k10-inner {
          display: flex;
          width: 100%;
        }
        .k10-track {
          display: flex;
          flex-shrink: 0;
          min-width: 100%;
          will-change: transform;
          animation: k10scroll 28s linear infinite;
        }
        @keyframes k10scroll {
          0%   { transform: translateX(0%); }
          100% { transform: translateX(-100%); }
        }
        .k10-item {
          font-size: 13px;
          color: #333;
          white-space: nowrap;
          padding: 0 22px;
          display: flex;
          align-items: center;
          gap: 9px;
        }
        .k10-off {
          background: #F15A22;
          color: #fff;
          font-size: 10.5px;
          font-weight: 800;
          padding: 2px 8px;
          border-radius: 4px;
          letter-spacing: 0.5px;
          flex-shrink: 0;
        }
        .k10-sep {
          color: #3AAA35;
          font-weight: 800;
          font-size: 16px;
          margin-left: 4px;
        }

        /* ════════════════════════════════════════════════════════════
           Sticky Header
        ════════════════════════════════════════════════════════════ */
        .is-sticky {
          position: fixed !important;
          top: 0; left: 0;
          width: 100%;
          box-shadow: 0 2px 12px rgba(0,0,0,0.1);
          animation: slideDown 0.35s ease-out;
          z-index: 1000;
        }
        @keyframes slideDown {
          from { transform: translateY(-100%); }
          to   { transform: translateY(0); }
        }

        /* ════════════════════════════════════════════════════════════
           Logo — BIGGER
        ════════════════════════════════════════════════════════════ */
        .logo img {
          max-width: 120px !important;
          display: block;
        }
        .logo {
          padding-left: 12px;
        }

        /* ════════════════════════════════════════════════════════════
           Desktop Nav — BIGGER font
        ════════════════════════════════════════════════════════════ */
        .nav-menu__link {
          position: relative;
          text-decoration: none !important;
          transition: color 0.3s ease;
          padding: 6px 0;
          font-size: 16px !important;
          font-weight: 500;
        }
        .nav-menu__link::after {
          content: '';
          position: absolute;
          width: 0; height: 2px;
          bottom: -3px; left: 0;
          background-color: #1B4F9B;
          transition: width 0.3s ease;
        }
        .nav-menu__link:hover::after,
        .nav-menu__link.active::after { width: 100%; }
        .nav-menu__link:hover { color: #1B4F9B !important; }

        .nav-menu.flex-align { gap: 28px !important; }

        /* ════════════════════════════════════════════════════════════
           Header inner
        ════════════════════════════════════════════════════════════ */
        .header-inner {
          min-height: unset !important;
          padding-top: 4px !important;
          padding-bottom: 4px !important;
        }

        /* ════════════════════════════════════════════════════════════
           Mega Menu
        ════════════════════════════════════════════════════════════ */
        .mega-menu-dropdown {
          display: block;
          position: absolute;
          top: calc(100% + 8px); left: 50%;
          transform: translateX(-50%) translateY(12px);
          background: #fff;
          border: 1px solid #ececec;
          border-radius: 14px;
          box-shadow: 0 12px 40px rgba(0,0,0,0.13);
          padding: 20px 24px;
          z-index: 9999;
          min-width: 620px;
          opacity: 0; visibility: hidden; pointer-events: none;
          transition: all 0.25s ease;
        }
        .category-nav-item:hover .mega-menu-dropdown {
          opacity: 1; visibility: visible; pointer-events: auto;
          transform: translateX(-50%) translateY(0);
        }
        .mega-cat-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 4px;
        }
        .mega-cat-item {
          display: flex; align-items: center; gap: 10px;
          padding: 8px 12px; border-radius: 10px;
          color: #1A1A2E; cursor: pointer;
          background: none; border: none;
          width: 100%; text-align: left;
          font-size: 13px; font-weight: 500;
          transition: all 0.2s ease;
        }
        .mega-cat-item:hover { background: #FEF0EB; color: #F15A22 !important; }
        .mega-cat-img {
          width: 38px; height: 38px;
          border-radius: 50%; object-fit: cover;
          border: 2px solid #f0f0f0;
        }
        .mega-cat-placeholder {
          width: 38px; height: 38px;
          border-radius: 50%; background: #FEF0EB;
          display: flex; align-items: center; justify-content: center;
          font-size: 17px; border: 2px solid #f0e0d0;
        }

        /* ════════════════════════════════════════════════════════════
           Header Icons — NAV LINK SIZE
        ════════════════════════════════════════════════════════════ */
        .header-right {
          display: flex;
          align-items: center;
          gap: 20px;
          padding-right: 12px;
        }
        .header-icon-link {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 22px !important;   
          line-height: 1;
          color: #374151;
          position: relative;
          text-decoration: none;
          transition: color 0.3s ease, transform 0.3s ease;
        }
        .header-icon-link i {
          font-size: 22px !important;
        }
        .header-icon-link:hover {
          color: #1B4F9B !important;
          transform: translateY(-2px);
        }
        .cart-badge-brand {
          background-color: #F15A22 !important;
          color: #fff !important;
          font-size: 10px;
        }
        .wish-badge {
          background-color: #1B4F9B !important;
          color: #fff !important;
          font-size: 10px;
        }

        /* ════════════════════════════════════════════════════════════
           Account Dropdown
        ════════════════════════════════════════════════════════════ */
        .account-menu-wrapper { position: relative; }
        .account-icon-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 22px !important;
          color: #374151;
          cursor: pointer;
          transition: color 0.3s ease, transform 0.3s ease;
          background: none;
          border: none;
          padding: 0;
          line-height: 1;
        }
        .account-icon-btn i {
          font-size: 22px !important;
        }
        .account-icon-btn:hover {
          color: #1B4F9B !important;
          transform: translateY(-2px);
        }
        .account-dropdown {
          position: absolute; top: 120%; right: 0;
          background: #fff; border-radius: 12px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.12);
          padding: 10px; width: 180px;
          opacity: 0; visibility: hidden;
          transform: translateY(10px);
          transition: all 0.25s ease;
          z-index: 999;
        }
        .account-menu-wrapper:hover .account-dropdown {
          opacity: 1; visibility: visible; transform: translateY(0);
        }
        .account-item {
          display: block; padding: 10px 12px;
          font-size: 13px; color: #1a1a2e;
          border-radius: 8px; text-decoration: none;
          transition: all 0.2s ease;
        }
        .account-item:hover { background: #FEF0EB; color: #F15A22; }

        /* ════════════════════════════════════════════════════════════
           Hamburger
        ════════════════════════════════════════════════════════════ */
        .hamburger-btn {
          display: none;
          flex-direction: column; justify-content: center;
          align-items: center; gap: 5px;
          width: 38px; height: 38px;
          background: none; border: none; cursor: pointer;
          padding: 4px; border-radius: 8px;
          transition: background 0.2s; z-index: 1100;
        }
        .hamburger-btn:hover { background: #FEF0EB; }
        .hamburger-line {
          width: 22px; height: 2px;
          background: #1a1a2e; border-radius: 4px;
          transition: all 0.35s cubic-bezier(0.4,0,0.2,1);
          transform-origin: center;
        }
        .hamburger-btn.open .hamburger-line:nth-child(1) { transform: translateY(7px) rotate(45deg); }
        .hamburger-btn.open .hamburger-line:nth-child(2) { opacity: 0; transform: scaleX(0); }
        .hamburger-btn.open .hamburger-line:nth-child(3) { transform: translateY(-7px) rotate(-45deg); }

        /* ════════════════════════════════════════════════════════════
           Overlay
        ════════════════════════════════════════════════════════════ */
        .drawer-overlay {
          display: none; position: fixed; inset: 0;
          background: rgba(0,0,0,0.45); z-index: 1099;
          backdrop-filter: blur(2px);
          animation: fadeIn 0.25s ease;
        }
        .drawer-overlay.show { display: block; }
        @keyframes fadeIn { from { opacity:0; } to { opacity:1; } }

        /* ════════════════════════════════════════════════════════════
           Side Drawer
        ════════════════════════════════════════════════════════════ */
        .side-drawer {
          position: fixed; top: 0; left: 0;
          height: 100vh; width: 285px;
          background: #fff; z-index: 1100;
          transform: translateX(-100%);
          transition: transform 0.38s cubic-bezier(0.4,0,0.2,1);
          display: flex; flex-direction: column;
          box-shadow: 4px 0 30px rgba(0,0,0,0.15);
          overflow-y: auto; overflow-x: hidden;
          -webkit-overflow-scrolling: touch;
          overscroll-behavior: contain;
        }
        .side-drawer.open { transform: translateX(0); }

        .drawer-header {
          display: flex; align-items: center;
          justify-content: space-between;
          padding: 16px 20px;
          border-bottom: 1px solid #f0f0f0;
          position: sticky; top: 0;
          background: #fff; z-index: 2; flex-shrink: 0;
        }
        .drawer-close-btn {
          width: 32px; height: 32px; border-radius: 50%;
          border: none; background: #f5f5f5; cursor: pointer;
          font-size: 16px; display: flex;
          align-items: center; justify-content: center;
          transition: background 0.2s;
        }
        .drawer-close-btn:hover { background: #FEF0EB; }

        .drawer-nav { list-style: none; margin: 0; padding: 10px 0; flex: 1; }
        .drawer-nav li { border-bottom: 1px solid #f7f7f7; }
        .drawer-nav a,
        .drawer-nav button.drawer-nav-btn {
          display: flex; align-items: center; gap: 11px;
          padding: 13px 22px; font-size: 14px; font-weight: 500;
          color: #1a1a2e; text-decoration: none;
          background: none; border: none;
          width: 100%; text-align: left; cursor: pointer;
          transition: all 0.2s ease;
        }
        .drawer-nav a:hover,
        .drawer-nav button.drawer-nav-btn:hover {
          background: #FEF0EB; color: #F15A22; padding-left: 28px;
        }
        .drawer-nav a.active { color: #1B4F9B; font-weight: 600; }

        .drawer-cat-accordion { overflow: hidden; max-height: 0; transition: max-height 0.35s ease; }
        .drawer-cat-accordion.open { max-height: 600px; }
        .drawer-cat-sub {
          display: flex; align-items: center; gap: 10px;
          padding: 10px 30px; font-size: 13px; color: #333;
          background: none; border: none;
          width: 100%; text-align: left; cursor: pointer;
          transition: all 0.2s ease;
          border-bottom: 1px solid #f5f5f5;
        }
        .drawer-cat-sub:hover { background: #FEF0EB; color: #F15A22; }
        .drawer-cat-img  { width: 30px; height: 30px; border-radius: 50%; object-fit: cover; }
        .drawer-cat-placeholder {
          width: 30px; height: 30px; border-radius: 50%;
          background: #FEF0EB; display: flex;
          align-items: center; justify-content: center; font-size: 14px;
        }
        .cat-arrow { margin-left: auto; font-size: 11px; transition: transform 0.3s ease; }
        .cat-arrow.open { transform: rotate(180deg); }

        /* ════════════════════════════════════════════════════════════
           Responsive
        ════════════════════════════════════════════════════════════ */
        @media (max-width: 991px) {
          .hamburger-btn { display: flex; }
          .header-menu.d-lg-block { display: none !important; }
          .logo img { max-width: 110px !important; }
        }
        @media (min-width: 992px) {
          .hamburger-btn { display: none !important; }
        }
      `}</style>

      {/* ── Ticker ── */}
      <div className="k10-marquee-outer">
        <div className="k10-inner">
          <div className="k10-track"><OfferItems /></div>
          <div className="k10-track" aria-hidden="true"><OfferItems /></div>
        </div>
      </div>

      {/* ══════════════════════════════════════════════════════════════
          Main Header
      ══════════════════════════════════════════════════════════════ */}
      <header
        className={`header bg-white ${scroll ? "is-sticky" : ""}`}
        style={{
          transition: 'all 0.3s ease',
          zIndex: 1000,
          position: scroll ? 'fixed' : 'relative',
          display: headerHidden ? 'none' : undefined,
        }}
      >
        <div className='container container-lg'>
          <nav className='header-inner flex-between gap-16' style={{ paddingTop: '4px', paddingBottom: '4px' }}>

            {/* ── Logo ── */}
            <div className='logo flex-shrink-0'>
              <Link to='/'>
                <img src={Logo} alt='Kalpanamart' />
              </Link>
            </div>

            {/* ── Desktop Menu ── */}
            <div className='header-menu d-lg-block d-none'>
              <ul className='nav-menu flex-align' style={{ listStyle: 'none', margin: 0, padding: 0 }}>

                <li>
                  <NavLink to='/' className='nav-menu__link text-heading'>Home</NavLink>
                </li>

                <li>
                  <NavLink to='/about' className='nav-menu__link text-heading'>About</NavLink>
                </li>

                <li>
                  <NavLink to='/shop' className='nav-menu__link text-heading'>Shop</NavLink>
                </li>

                {/* Category mega menu */}
                <li className="position-relative category-nav-item">
                  <button
                    className="nav-menu__link text-heading flex-align gap-4 border-0 bg-transparent"
                    style={{ cursor: 'pointer' }}
                  >
                    Category
                    <i className='ph ph-caret-down' style={{ fontSize: '12px' }} />
                  </button>
                  <div className="mega-menu-dropdown">
                    <div className="mega-cat-grid">
                      {categories.length > 0
                        ? categories.map(cat => (
                          <button key={cat.id} className="mega-cat-item" onClick={() => handleCategoryClick(cat)}>
                            {cat.image
                              ? <img src={`${process.env.REACT_APP_API_URL}/${cat.image}`} alt={cat.name} className="mega-cat-img" />
                              : <div className="mega-cat-placeholder">🗂️</div>}
                            <span>{cat.name}</span>
                          </button>
                        ))
                        : <p style={{ color: '#aaa', fontSize: 12, gridColumn: 'span 3', padding: '4px 12px' }}>No categories found</p>
                      }
                    </div>
                  </div>
                </li>

                <li>
                  <NavLink to='/contact' className='nav-menu__link text-heading'>Contact</NavLink>
                </li>

              </ul>
            </div>

            {/* ── Right Icons ── */}
            <div className='header-right'>

              {/* Wishlist */}
              <Link title="Wishlist" to='/wishlist' className='header-icon-link'>
                <i className='ph ph-heart' />
                {wishlistCount > 0 && (
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill wish-badge shadow">
                    {wishlistCount}
                  </span>
                )}
              </Link>

              {/* Cart */}
              <Link title="Cart" to='/cart' className='header-icon-link'>
                <i className='ph ph-shopping-cart-simple' />
                {cartCount > 0 && (
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill cart-badge-brand shadow">
                    {cartCount}
                  </span>
                )}
              </Link>

              {/* Account — desktop only */}
              <div className="account-menu-wrapper d-none d-lg-block">
                <button className="account-icon-btn">
                  <i className='ph ph-user-circle' />
                </button>
                <div className="account-dropdown">
                  <Link to="/account" className="account-item">👤 My Profile</Link>
                  <Link to="/orders"  className="account-item">📦 My Orders</Link>
                </div>
              </div>

              {/* Hamburger — mobile only */}
              <button
                className={`hamburger-btn ${drawerOpen ? 'open' : ''}`}
                onClick={() => setDrawerOpen(!drawerOpen)}
                aria-label="Toggle menu"
              >
                <span className="hamburger-line" />
                <span className="hamburger-line" />
                <span className="hamburger-line" />
              </button>

            </div>
          </nav>
        </div>
      </header>

      {/* ── Overlay ── */}
      <div
        className={`drawer-overlay ${drawerOpen ? 'show' : ''}`}
        onClick={closeDrawer}
      />

      {/* ══════════════════════════════════════════════════════════════
          Side Drawer (mobile)
      ══════════════════════════════════════════════════════════════ */}
      <div className={`side-drawer ${drawerOpen ? 'open' : ''}`}>

        <div className="drawer-header">
          <img src={Logo} alt="Kalpanamart" style={{ maxWidth: '95px' }} />
          <button className="drawer-close-btn" onClick={closeDrawer}>✕</button>
        </div>

        <ul className="drawer-nav">
          <li>
            <NavLink
              to="/"
              className={({ isActive }) => isActive ? 'active' : ''}
              onClick={closeDrawer}
            >
              🏠 Home
            </NavLink>
          </li>
          <li><NavLink to="/about"   onClick={closeDrawer}>📖 About</NavLink></li>
          <li><NavLink to="/shop"    onClick={closeDrawer}>🛍️ Shop</NavLink></li>

          {/* Category accordion */}
          <li>
            <button className="drawer-nav-btn" onClick={() => setCatOpen(!catOpen)}>
              🗂️ Category
              <span className={`cat-arrow ${catOpen ? 'open' : ''}`}>▼</span>
            </button>
            <div className={`drawer-cat-accordion ${catOpen ? 'open' : ''}`}>
              {categories.map(cat => (
                <button key={cat.id} className="drawer-cat-sub" onClick={() => handleCategoryClick(cat)}>
                  {cat.image
                    ? <img src={`${process.env.REACT_APP_API_URL}/${cat.image}`} alt={cat.name} className="drawer-cat-img" />
                    : <div className="drawer-cat-placeholder">🗂️</div>}
                  {cat.name}
                </button>
              ))}
            </div>
          </li>

          <li><NavLink to="/contact" onClick={closeDrawer}>📞 Contact</NavLink></li>
          <li><NavLink to="/account" onClick={closeDrawer}>👤 My Profile</NavLink></li>
          <li><NavLink to="/orders"  onClick={closeDrawer}>📦 My Orders</NavLink></li>
        </ul>

      </div>
    </>
  );
};

export default HeaderOne;